import { Badge } from '@mui/material';
import React from 'react';
import { useIdentityNumNotificationsQuery } from '../../../../generated/core-api/graphql-react-query';

export default function NotifButtonWrapper(props: { children: React.ReactNode }) {
  const { children } = props;
  const numNotifications = useIdentityNumNotificationsQuery({}, {
    refetchOnWindowFocus: true,
    refetchInterval: 300000,
  });
  if ((numNotifications.data?.getUserInfo.numNotifications ?? 0) > 0) {
    return (
      <Badge badgeContent={4} variant="dot">
        {children}
      </Badge>
    );
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
